import { Component, OnInit } from '@angular/core';
import { ReviewItem } from './review-item.model';

@Component({
  selector: 'ld-review',
  templateUrl: 'reviews.template.html',
  styleUrls: ['reviews.style.css'],
})

export class ReviewComponent implements  OnInit {
  reviews;
  showReviews: boolean = true;

  constructor() {

  }
  ngOnInit() {
     this.reviews = this.generateReviews();
  }
  private generateReviews(): ReviewItem[] {
    let reviews: ReviewItem[] = [];

    let newReview1: ReviewItem = new ReviewItem();
    newReview1.reviewTitle = 'Everything was awesome and quick.';
    newReview1.reviewName = 'Kenneth B.';
    reviews.push(newReview1);

    let newReview2: ReviewItem = new ReviewItem();
    newReview2.reviewTitle = 'Straightforward and easy.';
    newReview2.reviewName = 'Michael K.';
    reviews.push(newReview2);

    let newReview3: ReviewItem = new ReviewItem();
    newReview3.reviewTitle = '5 across the board.';
    newReview3.reviewName = 'Daniel R.';
    reviews.push(newReview3);

    let newReview4: ReviewItem = new ReviewItem();
    newReview4.reviewTitle = 'Very easy to use.';
    newReview4.reviewName = 'Kimberly F.';
    reviews.push(newReview4);

    return reviews;
  }
}
